module.exports = __webpack_public_path__ + "1543ec544f7aab9d7ee2945cf789b157.svg";